// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3EiWn","label":"SetPasswdForm_label__2qYF9"};